var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "income-statement", attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-4 left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.incomestatement")) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 right" }, [
            _c("div", { staticClass: "action" }, [
              _c("div", { staticClass: "dropdown item" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn no-bg text-secondary dropdown-toggle",
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-filter" }),
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("message.filter")) +
                        "\n              "
                    ),
                    [
                      _vm.select_date == "1"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.today")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_date == "2"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.thismonth")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_date == "3"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.thisyear")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_date == "4"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.7daysago")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_date == "5"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.1monthago")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_date == "6"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.6monthsago")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_date == "7"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.1yearago")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_date == "8"
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.custom")))
                          ])
                        : _vm._e()
                    ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-menu dropdown-menu-right" },
                  [
                    _c(
                      "form",
                      {
                        staticClass: "px-3 py-2",
                        staticStyle: { "min-width": "300px" }
                      },
                      [
                        _c("div", { staticClass: "form-group mb-0" }, [
                          _c("label", [_vm._v(_vm._s(_vm.$t("message.date")))]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.select_date,
                                  expression: "select_date"
                                }
                              ],
                              ref: "select-date",
                              staticClass: "custom-select",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.select_date = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "1" } }, [
                                _vm._v(_vm._s(_vm.$t("message.today")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "2" } }, [
                                _vm._v(_vm._s(_vm.$t("message.thismonth")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "3" } }, [
                                _vm._v(_vm._s(_vm.$t("message.thisyear")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "4" } }, [
                                _vm._v(_vm._s(_vm.$t("message.7daysago")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "5" } }, [
                                _vm._v(_vm._s(_vm.$t("message.1monthago")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "6" } }, [
                                _vm._v(_vm._s(_vm.$t("message.6monthsago")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "7" } }, [
                                _vm._v(_vm._s(_vm.$t("message.1yearago")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "8" } }, [
                                _vm._v(_vm._s(_vm.$t("message.custom")))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.select_date == "8"
                          ? _c(
                              "div",
                              {
                                staticClass: "form-group mt-3 mb-0",
                                staticStyle: { "margin-bottom": "5px" }
                              },
                              [
                                _c("BaseDateRange", {
                                  model: {
                                    value: _vm.date,
                                    callback: function($$v) {
                                      _vm.date = $$v
                                    },
                                    expression: "date"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready && _vm.income_statement !== null
            ? [
                _c("section", { staticClass: "mt-2" }, [
                  _c(
                    "div",
                    [
                      _c("section-title", {
                        attrs: {
                          title: _vm.datePeriod(_vm.date.start, _vm.date.end),
                          fontweight: "bold"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "mt-3" }, [
                  _c("div", { staticClass: "main row m-0" }, [
                    _c("div", { staticClass: "receive inner-main" }, [
                      _c("div", { staticClass: "thead" }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("apps.reports.message.income")) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 text-right" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("apps.reports.message.total")) +
                                "\n                "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "body" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "list pointer",
                              class: [{ active: this.state.show_sales }],
                              on: {
                                click: function($event) {
                                  return _vm.showSales()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "item form-row col-12 pl-1 pr-1 m-0"
                                },
                                [
                                  _c("div", { staticClass: "col-6" }, [
                                    _c("i", {
                                      staticClass: "fas",
                                      class: [
                                        {
                                          "fa-angle-right": !this.state
                                            .show_sales,
                                          "fa-angle-down": this.state.show_sales
                                        }
                                      ]
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.reports.message.salesservices"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 text-right" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            {
                                              "text-underline-border": this
                                                .state.show_sales
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumber(
                                                _vm.receipts.sale.total
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              this.state.show_sales
                                ? _c("div", { staticClass: "details" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "list pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.showSalePos()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item form-row col-12 pl-1 pr-1 m-0"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-6 pl-4" },
                                              [
                                                _c("i", {
                                                  staticClass: "fas",
                                                  class: [
                                                    {
                                                      "fa-angle-right": !this
                                                        .state.show_sale_pos,
                                                      "fa-angle-down": this
                                                        .state.show_sale_pos
                                                    }
                                                  ]
                                                }),
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.reports.message.pos"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 text-right"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      {
                                                        "text-underline-border": this
                                                          .state.show_sale_pos
                                                      }
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumber(
                                                          _vm.receipts.sale.pos
                                                            .total
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        this.state.show_sale_pos
                                          ? _vm._l(
                                              _vm.receipts.sale.pos.details,
                                              function(data, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "detais"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "list" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "item form-row col-12 pl-1 pr-1 m-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 pl-5"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      data.item
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 text-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      _vm.getNumber(
                                                                        data.total
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "list pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.showSaleOther()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item form-row col-12 pl-1 pr-1 m-0"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-6 pl-4" },
                                              [
                                                _c("i", {
                                                  staticClass: "fas",
                                                  class: [
                                                    {
                                                      "fa-angle-right": !this
                                                        .state.show_sale_other,
                                                      "fa-angle-down": this
                                                        .state.show_sale_other
                                                    }
                                                  ]
                                                }),
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.reports.message.saleother"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 text-right"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      {
                                                        "text-underline-border": this
                                                          .state.show_sale_other
                                                      }
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumber(
                                                          _vm.receipts.sale
                                                            .other.total
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        this.state.show_sale_other
                                          ? _vm._l(
                                              _vm.receipts.sale.other.details,
                                              function(data, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "detais"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "list" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "item form-row col-12 pl-1 pr-1 m-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 pl-5"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      data.item
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 text-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      _vm.getNumber(
                                                                        data.total
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.receipts.taxes, function(tax, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "list" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item form-row col-12 pl-1 pr-1 m-0"
                                  },
                                  [
                                    _c("div", { staticClass: "col-6" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.getMasterDataTextWithRegex(
                                              tax.displayText,
                                              _vm.$t
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 text-right" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getNumber(tax.total))
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "list" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "item form-row col-12 pl-1 pr-1 m-0"
                              },
                              [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "apps.reports.message.totalincome"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6 text-right" }, [
                                  _c(
                                    "span",
                                    { staticClass: "text-underline-border" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getNumber(_vm.receipts.total)
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "payments inner-main" }, [
                      _c("div", { staticClass: "thead" }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t(
                                    "apps.reports.message.operatingexpenses"
                                  )
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 text-right" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("apps.reports.message.total")) +
                                "\n                "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "body" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "list pointer",
                              class: [{ active: this.state.show_purchase }],
                              on: {
                                click: function($event) {
                                  return _vm.showPurchase()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "item form-row col-12 pl-1 pr-1 m-0"
                                },
                                [
                                  _c("div", { staticClass: "col-6" }, [
                                    _c("i", {
                                      staticClass: "fas",
                                      class: [
                                        {
                                          "fa-angle-right": !this.state
                                            .show_purchase,
                                          "fa-angle-down": this.state
                                            .show_purchase
                                        }
                                      ]
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.reports.message.costofgoodssold"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 text-right" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            {
                                              "text-underline-border": this
                                                .state.show_purchase
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumber(
                                                _vm.payments.purchase.total
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              this.state.show_purchase
                                ? _vm._l(
                                    _vm.payments.purchase.details,
                                    function(data, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "detais" },
                                        [
                                          _c("div", { staticClass: "list" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "item form-row col-12 pl-1 pr-1 m-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-6 pl-4" },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(data.item) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 text-right"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.getNumber(
                                                            data.total
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "list pointer",
                              class: [{ active: this.state.show_expenses }],
                              on: {
                                click: function($event) {
                                  return _vm.showExpenses()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "item form-row col-12 pl-1 pr-1 m-0"
                                },
                                [
                                  _c("div", { staticClass: "col-6" }, [
                                    _c("i", {
                                      staticClass: "fas",
                                      class: [
                                        {
                                          "fa-angle-right": !this.state
                                            .show_expenses,
                                          "fa-angle-down": this.state
                                            .show_expenses
                                        }
                                      ]
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.reports.message.expenses"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 text-right" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            {
                                              "text-underline-border": this
                                                .state.show_expenses
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumber(
                                                _vm.payments.expense.total
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              this.state.show_expenses
                                ? _c("div", { staticClass: "details" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "list pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.showExpenseCompany()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item form-row col-12 pl-1 pr-1 m-0"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-6 pl-4" },
                                              [
                                                _c("i", {
                                                  staticClass: "fas",
                                                  class: [
                                                    {
                                                      "fa-angle-right": !this
                                                        .state
                                                        .show_expense_company,
                                                      "fa-angle-down": this
                                                        .state
                                                        .show_expense_company
                                                    }
                                                  ]
                                                }),
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.reports.message.payforcompany"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 text-right"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      {
                                                        "text-underline-border": this
                                                          .state
                                                          .show_expense_company
                                                      }
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumber(
                                                          _vm.payments.expense
                                                            .company.total
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        this.state.show_expense_company
                                          ? _vm._l(
                                              _vm.payments.expense.company
                                                .details,
                                              function(data, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "detais"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "list" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "item form-row col-12 pl-1 pr-1 m-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 pl-5"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      data.item
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 text-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      _vm.getNumber(
                                                                        data.total
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "list pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.showExpensePerson()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item form-row col-12 pl-1 pr-1 m-0"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-6 pl-4" },
                                              [
                                                _c("i", {
                                                  staticClass: "fas",
                                                  class: [
                                                    {
                                                      "fa-angle-right": !this
                                                        .state
                                                        .show_expense_person,
                                                      "fa-angle-down": this
                                                        .state
                                                        .show_expense_person
                                                    }
                                                  ]
                                                }),
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.reports.message.payforemployee"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 text-right"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      {
                                                        "text-underline-border": this
                                                          .state
                                                          .show_expense_person
                                                      }
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumber(
                                                          _vm.payments.expense
                                                            .person.total
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        this.state.show_expense_person
                                          ? _vm._l(
                                              _vm.payments.expense.person
                                                .details,
                                              function(data, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "detais"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "list" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "item form-row col-12 pl-1 pr-1 m-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 pl-5"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      data.item
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 text-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      _vm.getNumber(
                                                                        data.total
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "list pointer",
                              class: [{ active: this.state.show_payroll }],
                              on: {
                                click: function($event) {
                                  return _vm.showPayroll()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "item form-row col-12 pl-1 pr-1 m-0"
                                },
                                [
                                  _c("div", { staticClass: "col-6" }, [
                                    _c("i", {
                                      staticClass: "fas",
                                      class: [
                                        {
                                          "fa-angle-right": !this.state
                                            .show_payroll,
                                          "fa-angle-down": this.state
                                            .show_payroll
                                        }
                                      ]
                                    }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.reports.message.costofpayslips"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 text-right" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            {
                                              "text-underline-border": this
                                                .state.show_payroll
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumber(
                                                _vm.payments.payroll.total
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              this.state.show_payroll
                                ? _vm._l(_vm.payments.payroll.details, function(
                                    data,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "detais" },
                                      [
                                        _c("div", { staticClass: "list" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "item form-row col-12 pl-1 pr-1 m-0"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-6 pl-4" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(data.item) +
                                                      "\n                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 text-right"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.getNumber(
                                                          data.total
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.payments.taxes, function(tax, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "list" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item form-row col-12 pl-1 pr-1 m-0"
                                  },
                                  [
                                    _c("div", { staticClass: "col-6" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.getMasterDataTextWithRegex(
                                              tax.displayText,
                                              _vm.$t
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 text-right" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getNumber(tax.total))
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "list" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "item form-row col-12 pl-1 pr-1 m-0"
                              },
                              [
                                _c("div", { staticClass: "col-6" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "apps.reports.message.totaloperatingexpenses"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6 text-right" }, [
                                  _c(
                                    "span",
                                    { staticClass: "text-underline-border" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getNumber(_vm.payments.total)
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "mt-3" }, [
                  _c("div", { staticClass: "row p-0 m-0" }, [
                    _c("div", { staticClass: "col-6 ml-auto p-0 pl-2" }, [
                      _c("p", { staticClass: "m-0" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("apps.reports.message.summaryresults")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row p-0 m-0 mt-2" }, [
                        _c("div", { staticClass: "col-8 p-0" }, [
                          _vm._v(
                            _vm._s(_vm.$t("apps.reports.message.pretaxincome"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 p-0 text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getNumber(
                                _vm.income_statement.totals.pretaxincome
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row p-0 m-0 mt-2" }, [
                        _c("div", { staticClass: "col-8 p-0" }, [
                          _vm._v(
                            _vm._s(_vm.$t("apps.reports.message.netincome"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 p-0 text-right" }, [
                          _c("span", { staticClass: "text-underline-border" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getNumber(
                                  _vm.income_statement.totals.netincome
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54e00baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e00baa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/report/income-statement/All.vue
// module id = null
// module chunks = 